import { useEffect, useRef, useState } from "react";
import "./omniads-products-banner.css";

type Product = {id:string; title:string; merchant:string; imageUrl:string|null; productUrl:string};
type State = "idle"|"loading"|"ready"|"awaiting-permissions";
const SHOP="https://omnishopper.cz/?utm_source=pedikura-dita&utm_medium=referral&utm_campaign=pece-o-nohy";

export default function OmniadsProductsBanner() {
  const section = useRef<HTMLElement>(null);
  const [status,setStatus] = useState<State>("idle");
  const [products,setProducts] = useState<Product[]>([]);
  useEffect(()=>{
    const node=section.current;
    if(!node)return;
    const controller=new AbortController();
    let fetched=false;
    const load=async()=>{
      if(fetched)return;
      fetched=true;
      setStatus("loading");
      try{
        const res=await fetch("/api/omniads/approved-products",{signal:controller.signal,credentials:"omit"});
        if(!res.ok)throw new Error("Feed unavailable");
        const data=await res.json() as {status?:string;products?:Product[]};
        if(controller.signal.aborted)return;
        if(data.status==="ready"&&Array.isArray(data.products)&&data.products.length){
          setProducts(data.products.slice(0,6));
          setStatus("ready");
        }else{setStatus("awaiting-permissions");}
      }catch{if(!controller.signal.aborted)setStatus("awaiting-permissions");}
    };
    if(!("IntersectionObserver" in window)){void load();return()=>controller.abort();}
    const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();void load();}},{rootMargin:"260px"});
    observer.observe(node);
    return()=>{observer.disconnect();controller.abort();};
  },[]);
  return <section ref={section} className="dita-omniads-banner" aria-labelledby="dita-omniads-title" data-source="omnishopper-public-approved-products">
    <div className="dita-omniads-inner">
      <div className="dita-omniads-label"><span aria-hidden="true">✦</span> OMNISHOPPER <span className="dita-omniads-sep">/</span> PRO DOMÁCÍ PÉČI</div>
      <div className="dita-omniads-head">
        <div><h2 id="dita-omniads-title">Malé rituály, velký pocit pohodlí.</h2><p>Inspirace pro péči o chodidla, nehty a chvíle relaxace mezi návštěvami salonu.</p></div>
        <a href={SHOP} className="dita-omniads-link" target="_blank" rel="nofollow sponsored noopener noreferrer">Objevovat OMNISHOPPER <span aria-hidden="true">↗</span></a>
      </div>
      {status==="ready" && products.length>0 ? <div className="dita-omniads-rail" role="region" tabIndex={0} aria-label="Schválené aktuální partnerské nabídky">
        {products.map(product=><article className="dita-omniads-card" key={product.id}>
          {product.imageUrl ? <img src={product.imageUrl} alt="" width="200" height="150" loading="lazy" decoding="async" referrerPolicy="no-referrer"/> : <div className="dita-omniads-image-fallback" aria-hidden="true">✿</div>}
          <span>{product.merchant}</span><strong>{product.title}</strong>
          <a href={product.productUrl} target="_blank" rel="nofollow sponsored noopener noreferrer">Zobrazit u prodejce ↗</a>
        </article>)}
      </div> : <div className="dita-omniads-fallback">
        <span className="dita-omniads-orbit" aria-hidden="true">✿</span>
        <div><strong>Výběr pro domácí péči připravujeme</strong><p>{status==="loading"?"Ověřuji dostupnost schválených partnerských nabídek…":"Ověřené produktové nabídky zatím nejsou v partnerském katalogu dostupné. Prohlédněte si zatím přímo OMNISHOPPER."}</p></div>
        <a href={SHOP} target="_blank" rel="nofollow sponsored noopener noreferrer">Přejít do katalogu ↗</a>
      </div>}
      <p className="dita-omniads-legal">Externí nákupní inspirace. Odkazy na produkty mohou být partnerské. Nabídky, ceny a dostupnost vždy potvrzuje příslušný prodejce. Telefonické objednávky pedikúry vyřizuje přímo Dita.</p>
    </div>
  </section>;
}
